<template>
    <v-container grid-list-md text-xs-center mt-1>
        <v-tabs fixed-tabs v-model="tabs">
<!--            <v-tab>-->
<!--                Carte des visites-->
<!--            </v-tab>-->
            <v-tab>
                Une superbe Valentine
            </v-tab>
            <v-tab>
                Mon beau texte
            </v-tab>
            <v-tab>
                Youtube
            </v-tab>
        </v-tabs>
        <v-tabs-items dark v-model="tabs">
<!--            <v-tab-item>-->
<!--                <v-card>-->
<!--                    <l-map-->
<!--                            :zoom="zoom"-->
<!--                            :center="center"-->
<!--                            :options="mapOptions"-->
<!--                            style="height: 500px"-->
<!--                            @update:center="centerUpdate"-->
<!--                            @update:zoom="zoomUpdate"-->
<!--                    >-->
<!--                        <l-tile-layer :url="url" :attribution="attribution"/>-->
<!--                        <l-marker v-for="(item, i) in places" :lat-lng="latLng(item.pos.latitude, item.pos.longitude)"-->
<!--                                  :key="i">-->
<!--                            <l-popup>-->
<!--                                <p>{{ item.display_name }}</p>-->
<!--                                <v-btn>Supprimer</v-btn>-->
<!--                                <v-btn>Marquer comme visité</v-btn>-->
<!--                            </l-popup>-->
<!--                        </l-marker>-->
<!--                    </l-map>-->
<!--                    <v-text-field-->
<!--                            class="mt-5"-->
<!--                            v-model="search"-->
<!--                            label="Recherche"-->
<!--                            single-line-->
<!--                            outline-->
<!--                    ></v-text-field>-->
<!--                    <v-btn @click="searchPlaces">Recherche</v-btn>-->

<!--                    <v-list two-line subheader>-->
<!--                        <v-list-tile-->
<!--                                v-for="item in foundPlaces"-->
<!--                                :key="item.title"-->
<!--                        >-->
<!--                            <v-list-tile-content>-->
<!--                                <v-list-tile-title>{{ item.address.city || item.address.state }}</v-list-tile-title>-->
<!--                                <v-list-tile-sub-title>{{ item.address.country }}</v-list-tile-sub-title>-->
<!--                            </v-list-tile-content>-->

<!--                            <v-list-tile-action>-->
<!--                                <v-btn icon ripple>-->
<!--                                    <v-icon @click="addLocation(item.lat, item.lon, item.display_name)"-->
<!--                                            color="grey lighten-1">add-->
<!--                                    </v-icon>-->
<!--                                </v-btn>-->
<!--                            </v-list-tile-action>-->
<!--                        </v-list-tile>-->
<!--                    </v-list>-->
<!--                </v-card>-->
<!--            </v-tab-item>-->
            <v-tab-item>
                <v-card>
                    <v-card-text>
                        <MyValentine></MyValentine>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card>
                    <v-card-text>
                        <MyText></MyText>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card>
                    <v-card-text>
                        <Youtube></Youtube>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

        <div class="display-2 mt-5">Je t'aime ❤️</div>

        <v-layout class="my-5 py-5" align-center row fill-height>
            <v-flex xs12>
                <div class="my-heart">
                    <div class="heart pulse"></div>
                </div>
            </v-flex>
        </v-layout>

        <News></News>
    </v-container>
</template>

<script>
import showdown from 'showdown';

import { latLng } from 'leaflet';
import {
  LMap, LTileLayer, LMarker, LPopup, LTooltip,
} from 'vue2-leaflet';
import ky from 'ky';
import News from '../components/News.vue';
import MyText from '../components/MyText.vue';
import MyValentine from '../components/MyValentine.vue';
import Youtube from '../components/Youtube.vue';

const db = firebase.firestore();

/*
const markerHtmlStyles = `
  background-color: #fff;
  width: 3rem;
  height: 3rem;
  display: block;
  left: -1.5rem;
  top: -1.5rem;
  position: relative;
  border-radius: 3rem 3rem 0;
  transform: rotate(45deg);
  border: 1px solid #FFFFFF`;

const icon = DivIcon({
  className: 'my-custom-pin',
  iconAnchor: [0, 24],
  labelAnchor: [-6, 0],
  popupAnchor: [0, -36],
  html: `<span style="${markerHtmlStyles}" />`,
});
*/

export default {
  name: 'home',
  components: {
    News,
    MyText,
    MyValentine,
    Youtube,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
  },
  data() {
    return {
      search: '',
      foundPlaces: [],

      places: [],
      zoom: 2,
      center: latLng(47.41322, -1.219482),
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },

      tabs: null,
      converter: new showdown.Converter(),
    };
  },
  computed: {
    md() {
      return this.converter.makeHtml(this.text);
    },
  },
  methods: {
    // eslint-disable-next-line
      async addLocation(lat, lon, display_name) {
      console.log(parseFloat(lat), parseFloat(lon));
      await db.collection('places').add({
        pos: new firebase.firestore.GeoPoint(parseFloat(lat), parseFloat(lon)),
        visited: false,
        display_name,
      });
    },
    async searchPlaces() {
      const parsed = await ky.get(`http://open.mapquestapi.com/nominatim/v1/search.php?key=WBCbslOKJ6QU6OyLzT3gHzjAjBPXACRJ&format=json&q=${this.search}&addressdetails=1`)
        .json();
      console.log(parsed);
      this.foundPlaces = parsed;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      // alert('Click!');
    },
    latLng,
  },
  mounted() {
    db.collection('places')
      .onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          console.log(data);
          if (doc.exists) this.places.push(data);
        });
      });
  },
};
</script>

<style>
    .heart {
        margin: 0 auto;
        position: relative;
        display: block;
        width: 100px;
        height: 100px;
        background: #f14ba3;
        border-radius: 0 0 0 10px;
        transform: rotate(-45deg);
        animation: pulse 1s infinite;
    }

    .heart::before,
    .heart::after {
        position: absolute;
        content: "";
        width: 100px;
        height: 100px;
        background: #f14ba3;
        border-radius: 50%;
    }

    .heart::before {
        top: -50px;
        left: 0;
    }

    .heart::after {
        top: 0;
        right: -50px;
    }

    @keyframes pulse {
        0%, 20% {
            transform: rotate(-45deg) scale(1);
        }
        30% {
            transform: rotate(-45deg) scale(1.2);
        }
        50% {
            transform: rotate(-45deg) scale(1);
        }
        60% {
            transform: rotate(-45deg) scale(1.1);
        }
        70%, 100% {
            transform: rotate(-45deg) scale(1);
        }
    }

    .bg-42 {
        background-color: #424242;
    }
</style>
